import { render, staticRenderFns } from "./OneTemplate.vue?vue&type=template&id=7015d196&scoped=true"
import script from "./OneTemplate.vue?vue&type=script&lang=js"
export * from "./OneTemplate.vue?vue&type=script&lang=js"
import style0 from "./OneTemplate.vue?vue&type=style&index=0&id=7015d196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015d196",
  null
  
)

export default component.exports